import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { About } from './components/About';
import { Experience } from './components/Experience';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { SEOSchema } from '../../components/SEOSchema';

export default function Home() {
  return (
    <>
      <SEOSchema type="home" />
      <Header />
      <Hero />
      <Services />
      <About />
      <Experience />
      <Contact />
      <Footer />
    </>
  );
}
